import { forwardRef, HTMLProps } from 'react';

type TextareaProps = HTMLProps<HTMLTextAreaElement>;

const TextArea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, label, id, readOnly, ...rest }, ref) => (
    <div className={`mb-2 ${className ? className : "w-full"}`}>
      <label htmlFor={id} data-content={label} className="font-semibold text-sm">
        {label}
      </label>
      <textarea
        id={id}
        className={
          `flex h-20 rounded-md border border-input px-3 py-1 text-sm shadow-sm transition-colors placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 mt-1 w-full`
        }
        name={label}
        ref={ref}
        autoComplete="off"
        {...rest}
      />
    </div>
  )
);

export default TextArea;
